"use strict";

var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = _interopRequireDefault(require("./constants.js"));

var Topics = _constants.default.topics;

var MailServers =
/*#__PURE__*/
function () {
  function MailServers(web3) {
    _classCallCheck(this, MailServers);

    this.web3 = void 0;
    this.mailserver = "";
    this.symKeyID = "";
    this.web3 = web3;
  }

  _createClass(MailServers, [{
    key: "useMailserver",
    value: function () {
      var _useMailserver = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(enode, cb) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.web3.shh.generateSymKeyFromPassword("status-offline-inbox");

              case 2:
                this.symKeyID = _context.sent;
                this.web3.currentProvider.send({
                  id: new Date().getTime(),
                  jsonrpc: "2.0",
                  method: "admin_addPeer",
                  params: [enode]
                }, function (err, res) {
                  if (err) {
                    if (cb) {
                      return cb(err, false);
                    }

                    return;
                  }

                  if (!res.result) {
                    if (cb) {
                      return cb(err, false);
                    }

                    return;
                  }

                  setTimeout(function () {
                    _this.web3.shh.markTrustedPeer(enode).then(function () {
                      _this.mailserver = enode;

                      if (!cb) {
                        return true;
                      }

                      cb(null, true);
                    }).catch(function (e) {
                      if (!cb) {
                        return;
                      }

                      cb(e, false);
                    });
                  }, 1000);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function useMailserver(_x, _x2) {
        return _useMailserver.apply(this, arguments);
      }

      return useMailserver;
    }()
  }, {
    key: "requestUserMessages",
    value: function () {
      var _requestUserMessages = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(options, cb) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.requestChannelMessages(_constants.default.topics.CONTACT_DISCOVERY_TOPIC, options, cb);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestUserMessages(_x3, _x4) {
        return _requestUserMessages.apply(this, arguments);
      }

      return requestUserMessages;
    }()
  }, {
    key: "requestChannelMessages",
    value: function () {
      var _requestChannelMessages = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(topic, options, cb) {
        var topics, mailserverPeer, timeout, symKeyID, from, to, limit;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.mailserver === "")) {
                  _context3.next = 4;
                  break;
                }

                if (cb) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                return _context3.abrupt("return", cb("Mailserver is not set", false));

              case 4:
                topics = [topic.slice(0, 2) === "0x" ? topic : this.web3.utils.sha3(topic).slice(0, 10)];
                mailserverPeer = this.mailserver;
                timeout = options.timeout || 30; // seconds

                symKeyID = this.symKeyID;
                from = options.from || 0; // unix timestamp

                to = options.to || 0;
                limit = options.limit || 0;
                this.web3.currentProvider.send({
                  id: new Date().getTime(),
                  jsonrpc: "2.0",
                  method: "shhext_requestMessages",
                  params: [{
                    from: from,
                    limit: limit,
                    mailserverPeer: mailserverPeer,
                    symKeyID: symKeyID,
                    timeout: timeout,
                    to: to,
                    topics: topics
                  }]
                }, function (err, res) {
                  if (err) {
                    if (cb) {
                      return cb(err);
                    }

                    return false;
                  }

                  if (cb) {
                    return cb(null, true);
                  }

                  return true;
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestChannelMessages(_x5, _x6, _x7) {
        return _requestChannelMessages.apply(this, arguments);
      }

      return requestChannelMessages;
    }()
  }]);

  return MailServers;
}();

var _default = MailServers;
exports.default = _default;